import React from 'react';

import { useBookingFlow } from './BookingFlow/useBookingFlow';
import StepDateTime from './BookingFlow/StepDateTime';
import StepCourts from './BookingFlow/StepCourts';
import StepReview from './BookingFlow/StepReview';
import CustomerHeader from '../../components/CustomerHeader';

export default function BookingFlow() {
  const f = useBookingFlow();

  return (
    <div className="mobile-container min-h-screen pb-6">
      <CustomerHeader
        title="Book Court"
        subtitle={`Step ${f.step} of 3`}
        onBack={f.goBack}
      />

      {/* Progress bar */}
      <div className="bg-secondary h-2">
        <div
          className="h-full transition-all duration-300"
          style={{ width: `${(f.step / 3) * 100}%`, background: '#0057A8' }}
        />
      </div>

      <div className="p-6">
        {f.step === 1 && (
          <StepDateTime
            locations={f.locations}
            selectedLocation={f.selectedLocation}
            selectedDate={f.selectedDate}
            selectedTimeSlot={f.selectedTimeSlot}
            duration={f.duration}
            minDate={f.minDate}
            maxDate={f.maxDate}
            timeSlots={f.timeSlots}
            slotPricing={f.slotPricing}
            availability={f.availability}
            slotAvailabilityStatuses={f.slotAvailabilityStatuses}
            availabilityLoading={f.availabilityLoading}
            courtsPricing={f.courtsPricing}
            breakInfo={f.breakInfo}
            operatingHoursDisplay={f.operatingHoursDisplay}
            isLocationClosed={f.isLocationClosed}
            isTimeSlotPast={f.isTimeSlotPast}
            getConsecutiveSlots={f.getConsecutiveSlots}
            onLocationChange={f.handleLocationChange}
            onDateChange={f.handleDateChange}
            onDurationChange={f.handleDurationChange}
            onTimeSlotClick={f.handleTimeSlotSelection}
            onNext={f.handleDateTimeNext}
          />
        )}

        {f.step === 2 && (
          <StepCourts
            selectedLocation={f.selectedLocation}
            selectedDate={f.selectedDate}
            selectedTimeSlot={f.selectedTimeSlot}
            duration={f.duration}
            courtsRequested={f.courtsRequested}
            courtsPricing={f.courtsPricing}
            availableSports={f.availableSports}
            specialRequests={f.specialRequests}
            onAddCourt={f.addCourt}
            onRemoveCourt={f.removeCourt}
            onUpdateSport={f.updateCourtSport}
            onSpecialRequestsChange={f.setSpecialRequests}
            onBack={() => f.goToStep(1)}
            onNext={() => f.goToStep(3)}
          />
        )}

        {f.step === 3 && (
          <StepReview
            selectedLocation={f.selectedLocation}
            selectedDate={f.selectedDate}
            selectedTimeSlot={f.selectedTimeSlot}
            duration={f.duration}
            courtsRequested={f.courtsRequested}
            courtsPricing={f.courtsPricing}
            specialRequests={f.specialRequests}
            loading={f.loading}
            getConsecutiveSlots={f.getConsecutiveSlots}
            onBack={() => f.goToStep(2)}
            onSubmit={f.handleSubmitBooking}
          />
        )}
      </div>
    </div>
  );
}
